// Debug flag to control console logging

// Helper function for conditional logging
function debugLog(...args) {
}

// Executed after SWYM has loaded all necessary resources.
function onSwymLoadCallback(swat) {

  // Function to add product to wishlist
  function addToWishlist(productData, lid) {
    // Validate product data before sending to Swym
    if (!productData.variantId || !productData.productId || !productData.url) {
      return;
    }
    const product = {
      epi: productData.variantId,
      empi: productData.productId,
      du: productData.url
    };
    const onSuccess = function (addedListItem) {
      // Update the icon to full state
      updateWishlistIcon(productData.handle, true);
      // Notify PDP/Alpine
      window.dispatchEvent(new CustomEvent('wishlist:product-added', {
        detail: {
          productId: productData.productId,
          variantId: productData.variantId,
          url: productData.url
        }
      }));
    };
    const onError = function (error) {
      console.error("Swym addToList error:", error);
    };
    swat.addToList(lid, product, onSuccess, onError);
  }

  // Function to remove product from wishlist
  function removeFromWishlist(productData, lid) {
    // Validate product data before sending to Swym
    if (!productData.variantId || !productData.productId || !productData.url) {
      return;
    }
    const product = {
      epi: productData.variantId,
      empi: productData.productId,
      du: productData.url
    };
    const onSuccess = function (deletedProduct) {
      // Update the icon to empty state
      updateWishlistIcon(productData.handle, false);
      // Notify PDP/Alpine
      window.dispatchEvent(new CustomEvent('wishlist:product-removed', {
        detail: {
          productId: productData.productId,
          variantId: productData.variantId,
          url: productData.url
        }
      }));
    };
    const onError = function (error) {
      console.error("Swym deleteFromList error:", error);
    };
    swat.deleteFromList(lid, product, onSuccess, onError);
  }

  // Function to update a single wishlist icon
  function updateWishlistIcon(handle, isInWishlist) {
    const productItems = document.querySelectorAll('.product-item');
    productItems.forEach(productItem => {
      const productLink = productItem.querySelector('.product-item__aspect-ratio');
      if (productLink) {
        const productUrl = productLink.getAttribute('href');
        const urlParts = productUrl.split('/products/');
        if (urlParts.length > 1) {
          const productHandle = urlParts[1].split('?')[0].replace(/\/$/, '');
          if (productHandle === handle) {
            const wishlistIcon = productItem.querySelector('.product-item__wishlist-icon');
            if (wishlistIcon) {
              if (isInWishlist) {
                // Update icon to full state
                wishlistIcon.innerHTML = `
                  <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M12.25 16.6562L19 20.875V4H5.5V20.875L12.25 16.6562Z" fill="white" stroke="white" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="square"/>
                  </svg>
                `;
                wishlistIcon.setAttribute('data-in-wishlist', 'true');
              } else {
                // Update icon to empty state
                wishlistIcon.innerHTML = `
                  <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M12.25 16.6562L19 20.875V4H5.5V20.875L12.25 16.6562Z" stroke="white" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="square"/>
                  </svg>
                `;
                wishlistIcon.setAttribute('data-in-wishlist', 'false');
              }
            }
          }
        }
      }
    });
  }

  // Listen for PDP/Alpine events to keep PLP in sync
  window.addEventListener('wishlist:product-added', e => {
    const {
      productId
    } = e.detail || {};
    if (!productId) return;
    // Update any PLP card displaying this product
    const cards = document.querySelectorAll(`.product-item[data-product-id="${productId}"] .product-item__wishlist-icon`);
    cards.forEach(icon => {
      icon.innerHTML = `
        <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M12.25 16.6562L19 20.875V4H5.5V20.875L12.25 16.6562Z" fill="white" stroke="white" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="square"/>
        </svg>
      `;
      icon.setAttribute('data-in-wishlist', 'true');
    });
  });
  window.addEventListener('wishlist:product-removed', e => {
    const {
      productId
    } = e.detail || {};
    if (!productId) return;
    const cards = document.querySelectorAll(`.product-item[data-product-id="${productId}"] .product-item__wishlist-icon`);
    cards.forEach(icon => {
      icon.innerHTML = `
        <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M12.25 16.6562L19 20.875V4H5.5V20.875L12.25 16.6562Z" stroke="white" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="square"/>
        </svg>
      `;
      icon.setAttribute('data-in-wishlist', 'false');
    });
  });

  // Function to update wishlist icon when swatch changes
  function updateWishlistIconForSwatchChange(productItem, newProductUrl) {
    if (!newProductUrl) {
      return;
    }

    // Extract handle from the new product URL
    const urlParts = newProductUrl.split('/products/');
    if (urlParts.length <= 1) {
      return;
    }
    const newHandle = urlParts[1].split('?')[0].replace(/\/$/, '');

    // Get the current wishlist from global storage or fetch it
    if (window.wishlistId) {
      fetchListContentsAndCheckProduct(window.wishlistId, newHandle, productItem);
    }
  }

  // Function to check if a specific product is in the wishlist
  function fetchListContentsAndCheckProduct(lid, handle, productItem) {
    let listConfig = {
      "lid": lid
    };
    let onError = function (error) {
    };
    let onSuccess = function (listContents) {
      let isInWishlist = false;
      if (listContents && listContents.length > 0) {
        // Check if the new product handle is in the wishlist
        isInWishlist = listContents.some(item => {
          if (item.du) {
            const urlParts = item.du.split('/products/');
            if (urlParts.length > 1) {
              const itemHandle = urlParts[1].split('?')[0].replace(/\/$/, '');
              return itemHandle === handle;
            }
          }
          return false;
        });
      }

      // Update the specific product item's wishlist icon
      const wishlistIcon = productItem.querySelector('.product-item__wishlist-icon');
      if (wishlistIcon) {
        if (isInWishlist) {
          // Update icon to full state
          wishlistIcon.innerHTML = `
            <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M12.25 16.6562L19 20.875V4H5.5V20.875L12.25 16.6562Z" fill="white" stroke="white" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="square"/>
            </svg>
          `;
          wishlistIcon.setAttribute('data-in-wishlist', 'true');
        } else {
          // Update icon to empty state
          wishlistIcon.innerHTML = `
            <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M12.25 16.6562L19 20.875V4H5.5V20.875L12.25 16.6562Z" stroke="white" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="square"/>
            </svg>
          `;
          wishlistIcon.setAttribute('data-in-wishlist', 'false');
        }
      }
    };
    swat.fetchListCtx(listConfig, onSuccess, onError);
  }

  // Function to add swatch change listeners
  function addSwatchChangeListeners() {
    const swatchItems = document.querySelectorAll('.swatch-item');
    debugLog(`Found ${swatchItems.length} swatch items`);
    swatchItems.forEach(swatch => {
      // Remove existing listener to prevent duplicates
      swatch.removeEventListener('click', swatch.swatchChangeHandler);

      // Create new click handler for swatches
      swatch.swatchChangeHandler = function (e) {
        debugLog("Swatch clicked - all dataset:", e.currentTarget.dataset);
        debugLog("Swatch clicked - dataset keys:", Object.keys(e.currentTarget.dataset));
        const productItem = swatch.closest('.product-item');
        if (!productItem) {
          return;
        }
        const swatchData = e.currentTarget.dataset;
        const newProductId = swatchData.groupedProductId;
        const newVariantId = swatchData.groupedProductVariantId || swatchData.groupedProductId; // Fallback if no variant ID

        debugLog("Current product-item data:", {
          oldProductId: productItem.getAttribute('data-product-id'),
          oldVariantId: productItem.getAttribute('data-variant-id'),
          newProductId: newProductId,
          newVariantId: newVariantId
        });
        if (newProductId) {
          // Update the product-item's data attributes
          productItem.setAttribute('data-product-id', newProductId);
          if (newVariantId) {
            productItem.setAttribute('data-variant-id', newVariantId);
          }
          debugLog("Updated product-item data:", {
            productId: productItem.getAttribute('data-product-id'),
            variantId: productItem.getAttribute('data-variant-id')
          });

          // Update wishlist icon status for the new product
          updateWishlistIconForSwatchChange(productItem, swatchData.groupedProductAnchor);
        }
      };

      // Add the click listener
      swatch.addEventListener('click', swatch.swatchChangeHandler);
    });
  }

  // Function to add click event listeners to wishlist icons
  function addWishlistClickListeners(lid) {
    const wishlistIcons = document.querySelectorAll('.product-item__wishlist-icon');
    wishlistIcons.forEach(icon => {
      // Remove existing listener to prevent duplicates
      icon.removeEventListener('click', icon.wishlistClickHandler);

      // Create new click handler
      icon.wishlistClickHandler = function (e) {
        e.preventDefault();
        e.stopPropagation();
        const productItem = icon.closest('.product-item');
        if (!productItem) return;

        // Get product data (this will now reflect the current swatch selection)
        const productId = productItem.getAttribute('data-product-id');
        const variantId = productItem.getAttribute('data-variant-id');
        const productLink = productItem.querySelector('.product-item__aspect-ratio');
        debugLog("Wishlist click - Current product data:", {
          productId: productId,
          variantId: variantId,
          productLink: productLink ? productLink.getAttribute('href') : 'not found'
        });

        // Validate required data
        if (!productLink) {
          return;
        }
        if (!productId || productId === 'null' || productId === 'undefined') {
          return;
        }
        const productUrl = productLink.getAttribute('href');
        const urlParts = productUrl.split('/products/');
        if (urlParts.length > 1) {
          const handle = urlParts[1].split('?')[0].replace(/\/$/, '');

          // Parse IDs with validation
          const parsedProductId = parseInt(productId, 10);
          const parsedVariantId = parseInt(variantId, 10);

          // Validate parsed values
          if (isNaN(parsedProductId) || parsedProductId <= 0) {
            return;
          }
          if (isNaN(parsedVariantId) || parsedVariantId <= 0) {
            return;
          }

          // Get the current wishlist state
          const isInWishlist = icon.getAttribute('data-in-wishlist') === 'true';

          // Prepare product data with full URL and validated values
          const productData = {
            productId: parsedProductId,
            variantId: parsedVariantId,
            handle: handle,
            url: window.location.origin + productUrl // Ensure full URL
          };

          // Final validation before sending to Swym
          if (!productData.productId || !productData.variantId || !productData.url) {
            debugLog("Error: Missing required fields for Swym:", {
              productId: productData.productId,
              variantId: productData.variantId,
              url: productData.url
            });
            return;
          }

          // Toggle wishlist state
          if (isInWishlist) {
            removeFromWishlist(productData, lid);
          } else {
            addToWishlist(productData, lid);
          }
        }
      };

      // Add the click listener
      icon.addEventListener('click', icon.wishlistClickHandler);
    });
  }

  // Function to fetch list contents and update wishlist icons
  function fetchListContentsAndUpdateIcons(lid) {
    let listConfig = {
      "lid": lid
    };
    let onError = function (error) {
    };
    let onSuccess = function (listContents) {

      // Extract product IDs from the wishlist
      let wishlistProductIds = [];
      if (listContents && listContents.length > 0) {
        wishlistProductIds = listContents.map(item => {
          // Extract product ID from the URL or get it directly if available
          if (item.du) {
            const urlParts = item.du.split('/products/');
            if (urlParts.length > 1) {
              // Get the product handle and look for the product ID in the DOM
              const handle = urlParts[1].split('?')[0].replace(/\/$/, '');
              return handle;
            }
          }
          return null;
        }).filter(id => id !== null);
      }

      // Update wishlist icons for all product items on the page
      updateWishlistIcons(wishlistProductIds, swat, lid);
    };
    swat.fetchListCtx(listConfig, onSuccess, onError);
  }

  // Function to update wishlist icons based on wishlist contents
  function updateWishlistIcons(wishlistProductIds, swat, lid) {
    // Get all product items on the page
    const productItems = document.querySelectorAll('.product-item');
    productItems.forEach(productItem => {
      productItem.getAttribute('data-product-id');
      const wishlistIcon = productItem.querySelector('.product-item__wishlist-icon');
      if (wishlistIcon) {
        // Get the product URL to extract the handle
        const productLink = productItem.querySelector('.product-item__aspect-ratio');
        if (productLink) {
          const productUrl = productLink.getAttribute('href');
          const urlParts = productUrl.split('/products/');
          if (urlParts.length > 1) {
            const handle = urlParts[1].split('?')[0].replace(/\/$/, '');

            // Check if this product is in the wishlist
            if (wishlistProductIds.includes(handle)) {
              // Update icon to full state
              wishlistIcon.innerHTML = `
                <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M12.25 16.6562L19 20.875V4H5.5V20.875L12.25 16.6562Z" fill="white" stroke="white" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="square"/>
                </svg>
              `;

              // Add a data attribute to track the wishlist state
              wishlistIcon.setAttribute('data-in-wishlist', 'true');
            } else {
              // Keep icon as empty state
              wishlistIcon.innerHTML = `
                <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M12.25 16.6562L19 20.875V4H5.5V20.875L12.25 16.6562Z" stroke="white" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="square"/>
                </svg>
              `;
              wishlistIcon.setAttribute('data-in-wishlist', 'false');
            }
          }
        }
      }
    });

    // Add click event listeners after updating icons
    addWishlistClickListeners(lid);

    // Add swatch change listeners
    addSwatchChangeListeners();

    // Store functions globally for pagination re-initialization
    globalFetchListContentsAndUpdateIcons = fetchListContentsAndUpdateIcons;
  }

  // Define success callback for fetching lists
  let onSuccess = function (lists) {

    // Find the wishlist and get its ID
    let wishlistId = null;
    if (lists && lists.length > 0) {
      const myWishlist = lists.find(list => list.lname === "My Wishlist");
      if (myWishlist) {
        wishlistId = myWishlist.lid;

        // Store the wishlist ID globally for later use
        window.wishlistId = wishlistId;

        // Fetch list contents and update icons
        fetchListContentsAndUpdateIcons(wishlistId);
      }
    }

    // If no wishlist is found, create one
    if (!wishlistId) {
      let listConfig = {
        "lname": "My Wishlist"
      };
      let onCreateSuccess = function (newList) {
        if (newList && newList.lid) {
          window.wishlistId = newList.lid;
          debugLog("New Wishlist ID saved:", newList.lid);

          // Fetch list contents and update icons
          fetchListContentsAndUpdateIcons(newList.lid);
        }
      };
      let onCreateError = function (error) {
      };

      // Create a new list
      swat.createList(listConfig, onCreateSuccess, onCreateError);
    }
  };

  // Define error callback
  let onError = function (error) {
  };

  // Call `fetchLists` function
  swat.fetchLists({
    callbackFn: onSuccess,
    errorFn: onError
  });
}

// Register the callback function
if (!window.SwymCallbacks) {
  window.SwymCallbacks = [];
}
window.SwymCallbacks.push(onSwymLoadCallback);

// Store functions globally for pagination re-initialization
let globalFetchListContentsAndUpdateIcons = null;

// Listen for pagination content updates to re-initialize wishlist functionality (Safari compatibility fix)
document.addEventListener('pagination:content-updated', function (event) {

  // Re-initialize wishlist functionality for the new content
  if (window.wishlistId && window._swat && globalFetchListContentsAndUpdateIcons) {
    // Re-add event listeners and update icons for new content
    globalFetchListContentsAndUpdateIcons(window.wishlistId);
  } else if (window._swat) {
    // If wishlist ID is not available, try to fetch it again
    const onSuccess = function (lists) {

      // Find the wishlist and get its ID
      let wishlistId = null;
      if (lists && lists.length > 0) {
        const myWishlist = lists.find(list => list.lname === "My Wishlist");
        if (myWishlist) {
          wishlistId = myWishlist.lid;

          // Store the wishlist ID globally for later use
          window.wishlistId = wishlistId;

          // Fetch list contents and update icons if function is available
          if (globalFetchListContentsAndUpdateIcons) {
            globalFetchListContentsAndUpdateIcons(wishlistId);
          }
        }
      }
    };
    const onError = function (error) {
    };

    // Call `fetchLists` function to re-initialize
    window._swat.fetchLists({
      callbackFn: onSuccess,
      errorFn: onError
    });
  }
});
